const API_SUFFIX = 'API';
const CAPABILITIES_MANAGER = 'CapabilitiesManager';
const CONFIG_MANAGER = 'ConfigManager';
const EVENT_MANAGER = 'EventManager';
const PLUGINS_MANAGER = 'PluginsManager';
const USER_SESSION_MANAGER = 'UserSessionManager';
const ERROR_HANDLER = 'ErrorHandler';
const PLUGIN_ENGINE = 'PluginEngine';
const STORE_MANAGER = 'StoreManager';
const READY_API = `Ready${API_SUFFIX}`;
const LOAD_API = `Load${API_SUFFIX}`;
const EVENT_REPOSITORY = 'EventRepository';
const EXTERNAL_SRC_LOADER = 'ExternalSrcLoader';
const HTTP_CLIENT = 'HttpClient';
const RSA = 'RudderStackAnalytics';
const ANALYTICS_CORE = 'AnalyticsCore';
export {
  CAPABILITIES_MANAGER,
  CONFIG_MANAGER,
  EVENT_MANAGER,
  PLUGINS_MANAGER,
  USER_SESSION_MANAGER,
  ERROR_HANDLER,
  PLUGIN_ENGINE,
  STORE_MANAGER,
  READY_API,
  LOAD_API,
  EVENT_REPOSITORY,
  EXTERNAL_SRC_LOADER,
  HTTP_CLIENT,
  RSA,
  ANALYTICS_CORE,
  API_SUFFIX,
};
